import { createGlobalStyle } from 'styled-components'

import { media } from '@redriverpress/system'

/* eslint-disable max-len */
const ReactDateTimeStyle = createGlobalStyle`
  .rdt {
    position: relative;
  }

  /* Calendar */
  .rdtPicker {
    left: 5%;
    top: 0;
    width: 90%;
    display: none;
    position: fixed;
    padding: ${props => props.theme.space[3]} ${props => props.theme.space[2]};
    margin-top: 1px;
    z-index: 99999 !important;
    background: #fff;
    box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
    border: 2px solid ${props => props.theme.colors.blue500};
    border-radius: ${props => props.theme.radii.rounded};
  }
  ${media.md`
    .rdtPicker {
      position: absolute;
      left: auto;
      top: auto;
      width: auto;
    }
  `}
  .rdtOpen .rdtPicker {
    display: block !important;
  }
  .rdtStatic .rdtPicker {
    box-shadow: none;
    position: static;
  }

  .rdtPicker .rdtTimeToggle {
    text-align: center;
    font-size: 0;
  }

  .rdtPicker .rdtTimeToggle:before {
    font-family: "Font Awesome 5 Pro";
    content: "\f017";
    font-size: ${props => props.theme.fontSizes[1]};
  }
  .rdtPicker .rdtTimeToggle:after {
    content: " Pick Time";
    font-size: ${props => props.theme.fontSizes[1]};
  }

  .rdtPicker table {
    width: 100%;
    margin: 0;
  }
  .rdtPicker td,
  .rdtPicker th {
    text-align: center;
    padding: ${props => props.theme.space[1]} ${props => props.theme.space[2]};
    border-radius: ${props => props.theme.radii.rounded};
    line-height: 28px;
  }
  .rdtPicker td {
    cursor: pointer;
  }
  .rdtPicker td.rdtDay:hover,
  .rdtPicker td.rdtHour:hover,
  .rdtPicker td.rdtMinute:hover,
  .rdtPicker td.rdtSecond:hover,
  .rdtPicker .rdtTimeToggle:hover {
    background: ${props => props.theme.colors.blue100};
    cursor: pointer;
  }
  .rdtPicker td.rdtOld,
  .rdtPicker td.rdtNew {
    color: #999999;
  }

  /* Showing a different style on Today */
  .rdtPicker td.rdtToday {
    position: relative;
  }
  .rdtPicker td.rdtToday:before {
    content: '';
    display: inline-block;
    border-left: 7px solid transparent;
    border-bottom: 7px solid #428bca;
    border-top-color: rgba(0, 0, 0, 0.2);
    position: absolute;
    bottom: 4px;
    right: 4px;
  }

  /* Selected Date */
  .rdtPicker td.rdtActive,
  .rdtPicker td.rdtActive:hover {
    background-color: ${props => props.theme.colors.blue500};
    color: ${props => props.theme.colors.white};
    text-shadow: none !important;
    font-weight: 700;
    border-radius: ${props => props.theme.radii.rounded};
  }
  .rdtPicker td.rdtActive.rdtToday:before {
    border-bottom-color: #fff;
  }
  .rdtPicker td.rdtDisabled,
  .rdtPicker td.rdtDisabled:hover {
    background: none;
    color: #999999;
    cursor: not-allowed;
  }

  .rdtPicker td span.rdtOld {
    color: #999999;
  }
  .rdtPicker td span.rdtDisabled,
  .rdtPicker td span.rdtDisabled:hover {
    background: none;
    color: #999999;
    cursor: not-allowed;
  }
  .rdtPicker th {
    border-bottom: 1px solid #f9f9f9;
    border-radius: ${props => props.theme.radii.rounded};
  }

  /* Header for the day of the week */
  .rdtPicker .dow {
    width: 14.2857%;
    border-bottom: none;
    cursor: default;
    font-size: 12px;
  }
  /* Header showing the Month */
  .rdtPicker th.rdtSwitch {
    width: 100px;
    font-size: ${props => props.theme.fontSizes[3]};
    font-weight: 300;
    padding: ${props => props.theme.space[2]};
  }
  .rdtPicker th.rdtNext,
  .rdtPicker th.rdtPrev {
    font-size: 21px;
    vertical-align: middle;
  }

  .rdtPrev span,
  .rdtNext span {
    display: block;
    -webkit-touch-callout: none; /* iOS Safari */
    -webkit-user-select: none; /* Chrome/Safari/Opera */
    -khtml-user-select: none; /* Konqueror */
    -moz-user-select: none; /* Firefox */
    -ms-user-select: none; /* Internet Explorer/Edge */
    user-select: none;
  }

  /* Disabled Days */
  .rdtPicker th.rdtDisabled,
  .rdtPicker th.rdtDisabled:hover {
    background: none;
    color: #999999;
    cursor: not-allowed;
  }
  .rdtPicker thead tr:first-child th {
    cursor: pointer;
  }
  .rdtPicker thead tr:first-child th:hover {
    background: ${props => props.theme.colors.blue100};
  }

  .rdtPicker tfoot {
    border-top: 1px solid #f9f9f9;
  }

  .rdtPicker button {
    border: none;
    background: none;
    cursor: pointer;
  }
  .rdtPicker button:hover {
    background-color: ${props => props.theme.colors.blue100};
  }

  .rdtPicker thead button {
    width: 100%;
    height: 100%;
  }

  /* Month or Year pickers */
  td.rdtMonth,
  td.rdtYear {
    padding: ${props => props.theme.space[3]};
    font-size: ${props => props.theme.fontSizes[0]};
    cursor: pointer;
  }
  td.rdtMonth:hover,
  td.rdtYear:hover {
    background: ${props => props.theme.colors.blue100};
  }

  /* From here, all the 'counters' are for picking the time */
  .rdtCounters {
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .rdtCounterSeparator {
    padding: ${props => props.theme.space[3]};
  }

  .rdtCounter .rdtBtn {
    padding: ${props => props.theme.space[3]};
    cursor: pointer;
    display: block;

    -webkit-touch-callout: none; /* iOS Safari */
    -webkit-user-select: none; /* Chrome/Safari/Opera */
    -khtml-user-select: none; /* Konqueror */
    -moz-user-select: none; /* Firefox */
    -ms-user-select: none; /* Internet Explorer/Edge */
    user-select: none;
  }
  .rdtCounter .rdtBtn:hover {
    background: ${props => props.theme.colors.blue100};
  }
  .rdtCounter .rdtCount {
    font-size: ${props => props.theme.fontSizes[4]};
    padding: ${props => props.theme.space[3]};
    font-weight: 300;
  }

  ${media.md`
    .rdtCounter .rdtCount {
      font-size: ${props => props.theme.fontSizes[5]};
      padding: ${props => props.theme.space[4]};
    }
  `}

  .rdtMilli {
    vertical-align: middle;
    padding-left: 8px;
    width: 48px;
  }

  .rdtMilli input {
    width: 100%;
    font-size: 1.2em;
    margin-top: 37px;
  }

  .rdtTime td {
    cursor: default;
  }

  /* The mode switch at the top of the time picker */
  .rdtTime .rdtSwitch {
    cursor: pointer;

    &:hover {
      background: ${props => props.theme.colors.blue100};
    }
  }

`
/* eslint-enable */

export default ReactDateTimeStyle
